import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=40f8dfc8&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8dfc8",
  null
  
)

export default component.exports